export default {
  dragHandle: {
    color: '#222029',
    opacity: 0.8,
    fontSize: '20px',
    '&:hover': {
      opacity: 1,
    },
  },
  body: {
    display: "flex",
    width: 'fit-content',
    //background: "#EEECF8",
    flexDirection: "row",
  },
  sideBar: {
    //flex: "1",//"0 0 1",
    minWidth: '150px',
    padding: "10px",
    border: "1px solid #D9D8ED",
    //height: "100vh",
    background: "#fff",
  },
  sideBarItem: {
    fontSize: '11px',
    border: "1px solid #D9D8ED",
    padding: "0 5px",
    marginTop: "5px",
    color: '#4c4c4c',
    background: "#fff",
  },
  page: {
    flex: "1 1 auto",
    padding: "0 10px",
    minWidth: '100px',
    background: '#fff',
    border: '1px dashed #B9BBCD',
    //margin: "10px",
    //border: "1px solid green",
  },
  dropZone: {
    flex: "0 0 auto",
    height: "30px",
    background: "#EEECF8",
    transition: "200ms all",
  },
  dropZone_nth_of_type_2n: {
    display: "none",
  },
  dropZone_horizontalDrag: {
    width: "30px",
    height: "auto",
  },
  dropZone_not__horizontalDrag__isLast: {
    flex: "1 1 auto",
  },
  dropZone_active: {
    background: "#00a2ff",
    transition: "100ms all",
  },
  component: {
    //padding: "3px",
    background: "#D9D8ED",
  },
  column: {
    //border: "1px solid blue",
    border: '1px dashed #B9BBCD',
    flex: "1 1 100%",
    '&:hover': {
      border: '1px solid #347CFF',
    },
    //padding: "10px",
  },
  columns: {
    display: "flex",
    padding: "5px 0",
  },
  columnContainer: {
    display: "flex",
    flexDirection: 'column',
  },
  base: {
    padding: "0.5rem 1rem",
    backgroundColor: "white",
    cursor: "move",
  },
  baseDraggableRow: {
    width: "40px",
    height: "auto",
  },
  row: {
    //border: "1px solid red",
    border: '1px dashed #B9BBCD',
    padding: "0",
    '&:hover': {
      border: '1px solid #347CFF',
    },
  },
  trashDropZone: {
    position: "relative",
    textAlign: "center",
    borderRadius: '25px',
    margin: "20px",
    width: "50px",
    height: "50px",
    background: '#fff',
    border: "1px solid #D9D8ED",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  trashDropZone_active: {
    border: "1px solid #E91818",
    transition: "100ms all",
  },
  deleteComponentIcon: {
    color: '#989898',
  },
  deleteComponentIconActive: {
    color: '#E91818',
  },
  pageContainer: {
    display: "flex",
    alignItems: 'center',
    //flex: "1",
    flexDirection: "row",
    marginLeft: "10px",
  },
};
